import { ERROR_PLEASE_RELOAD } from 'mk/autogenerated/translations/editPost.8557621a974bbbdaaab7ba69c77ea2ef'
import * as msgs from 'mk/msgs';
import { photoblog_api_v1_get_post_title_url } from 'mk/urls/functions';
import * as xhr from 'mk/xhr/client';

declare const window: any;

export default function editPost(postId) {
    const url = photoblog_api_v1_get_post_title_url(postId);
    xhr
        .get(url)
        .then(
            (response) => {
                const message = response.body.title;
                window.pbEditPostModal(postId, message);
                return false;
            },
            () => msgs.error(ERROR_PLEASE_RELOAD),
        );
}
